/* jslint esversion: 6 */
/**
 * Favicon Badge
 *
 * Display a favicon badge on non-live environments to help differentiate tabs.
 *
 * @link http://lab.ejci.net/favico.js/
 *
 * @author Dylan James Wagner
 * @package Baseline
 * @subpackage Scripts
 * @since 2.0.0
 */
// const hosts = require('../../../../package.json').hosts;
const hosts = {
  "live":    "www.exampleproject.com",
  "test":    "test-exampleproject.pantheonsite.io",
  "dev":     "dev-exampleproject.pantheonsite.io",
  "updates": "updates-exampleproject.pantheonsite.io",
  "release": "release-exampleproject.pantheonsite.io",
  "develop": "develop-exampleproject.pantheonsite.io",
  "local":   "exampleproject.lndo.site",
  "xip":     "exampleproject.lndo.site.*.*.*.*.xip.io",
  "sync":    "sync-exampleproject.lndo.site"
};

const Favico = require('favico.js');

function init() {
  const host    = window.location.host;
  const live    = hosts.live    ? hosts.live    : 'www.colab-baseline.com';
  const test    = hosts.test    ? hosts.test    : 'test-colab-baseline.pantheonsite.io';
  const dev     = hosts.dev     ? hosts.dev     : 'dev-colab-baseline.pantheonsite.io';
  const updates = hosts.updates ? hosts.updates : 'updates-colab-baseline.pantheonsite.io';
  const release = hosts.release ? hosts.release : 'release-colab-baseline.pantheonsite.io';
  const develop = hosts.develop ? hosts.develop : 'develop-colab-baseline.pantheonsite.io';
  const local   = hosts.local   ? hosts.local   : 'colab-baseline.lndo.site';
  const xip     = hosts.xip     ? hosts.xip     : 'colab-baseline.lndo.site.*.*.*.*.xip.io';
  const sync    = hosts.sync    ? hosts.sync    : 'sync-colab-baseline.lndo.sit';

  if (host !== live) {
    const favico = new Favico({
      animation  : 'none',      // slide, fade, pop, popFade, none
      position   : 'down',      // down, left, up, upleft
      type       : 'rectangle', // circle, rectangle
      bgColor    : '#cc0000',   // #dc0000
      textColor  : '#ffffff',   // #ffffff
      fontFamily : 'mono',      // serif, sans-serif, mono, Arial, Verdana, ...
      fontStyle  : 'bold',      // normal, italic, oblique, bold, bolder, lighter, 100, 200, 300, 400, 500, 600, 700, 800, 900
    });

    /** replace xip.io IP address */
    // console.log(host + ' before');
    // host.replace('/([0-9]*)\.([0-9]*)\.([0-9]*)\.([0-9]*)\.xip\.io/g', '*.*.*.*.xip.io');
    // console.log(host + ' after');

    switch (host) {
      case test    : favico.badge('T'); break;
      case dev     : favico.badge('D'); break;
      case updates : favico.badge('U'); break;
      case release : favico.badge('R'); break;
      case develop : favico.badge('I'); break; // I for integration, D is already in use
      case local   : favico.badge('L'); break;
      case xip     : favico.badge('X'); break;
      case sync    : favico.badge('S'); break;
      // default      : favico.badge('?'); break;
    }
  }
}

export {init as default};
